import React from "react";
import { Route, Switch /* Redirect */ } from "react-router-dom";
import Layout from "../Layout/index";
import MainWrapper from "../App/MainWrapper";

import {
  UserRoutes,
  CardRequestRoutes,
  IssuerConfigRoutes,
  IssuerDomainMappingRoutes,
  CustomerRoutes,
  CardRecordsRoutes,
} from "./routeConstants";
import Dashboard from "../Dashboard";
import PermissionedRoute from "./PermissionedRoute";
import CardStatement from "../CardStatements/GetCardStatement/index";
import TransactionReport from "../TransactionReport/GetCardStatement/index";
import CardSearch from "../CardSearch/GetCard/index";
import { permissionsConstants } from "../../constants/permissions.constants";
import AuditTrail from "../AuditTrail/GetActivityLogs/index";

const Users = () => (
  <Switch>
    {UserRoutes.enabled &&
      UserRoutes.routes.map((route) =>
        route.enabled ? (
          <PermissionedRoute
            key={route.key}
            exact={route.exact}
            path={route.path}
            allowedPermissions={route.permissions}
            name={route.name}
            component={route.pageComponent}
          />
        ) : null
      )}
  </Switch>
);

const CardRequests = () => (
  <Switch>
    {CardRequestRoutes.enabled &&
      CardRequestRoutes.routes.map((route) =>
        route.enabled ? (
          <PermissionedRoute
            key={route.key}
            exact={route.exact}
            allowedPermissions={route.permissions}
            path={route.path}
            name={route.name}
            component={route.pageComponent}
          />
        ) : null
      )}
  </Switch>
);

const Customers = () => (
  <Switch>
    {CustomerRoutes.enabled &&
      CustomerRoutes.routes.map((route) =>
        route.enabled ? (
          <PermissionedRoute
            key={route.key}
            exact={route.exact}
            allowedPermissions={route.permissions}
            path={route.path}
            name={route.name}
            component={route.pageComponent}
          />
        ) : null
      )}
  </Switch>
);

const CardRecords = () => (
  <Switch>
    {CardRecordsRoutes.enabled &&
      CardRecordsRoutes.routes.map((route) =>
        route.enabled ? (
          <PermissionedRoute
            key={route.key}
            exact={route.exact}
            allowedPermissions={route.permissions}
            path={route.path}
            name={route.name}
            component={route.pageComponent}
          />
        ) : null
      )}
  </Switch>
);
// const AuditTrail = () => (
//     <Switch>{AuditTrailRoutes.enabled && CardRecordsRoutes.routes.map((route) => (route.enabled ? <PermissionedRoute key={route.key} exact={route.exact} allowedPermissions={route.permissions} path={route.path} name={route.name} component={route.pageComponent} /> : null))}</Switch>
// );

const IssuerConfigs = () => (
  <Switch>
    {IssuerConfigRoutes.enabled &&
      IssuerConfigRoutes.routes.map((route) =>
        route.enabled ? (
          <PermissionedRoute
            key={route.key}
            exact={route.exact}
            allowedPermissions={route.permissions}
            path={route.path}
            name={route.name}
            component={route.pageComponent}
          />
        ) : null
      )}
  </Switch>
);

const IssuerDomainMapping = () => (
  <Switch>
    {IssuerDomainMappingRoutes.enabled &&
      IssuerDomainMappingRoutes.routes.map((route) =>
        route.enabled ? (
          <PermissionedRoute
            key={route.key}
            exact={route.exact}
            path={route.path}
            allowedPermissions={route.permissions}
            name={route.name}
            component={route.pageComponent}
          />
        ) : null
      )}
  </Switch>
);

const Router = ({ hasError }) => (
  <Switch>
    <MainWrapper hasError={hasError}>
      <main>
        <div>
          <Layout />
          <div className="container__wrap">
            <Route exact path="/" component={Dashboard} />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/users" component={Users} />
            <Route path="/card-requests" component={CardRequests} />
            <Route path="/issuers/config" component={IssuerConfigs} />
            <Route path="/issuer-mapping" component={IssuerDomainMapping} />
            <Route path="/customers" component={Customers} />
            <Route path="/cards" component={CardRecords} />
            <PermissionedRoute
              path="/card-statement"
              allowedPermissions={[permissionsConstants.VIEW_CARD_STATEMENT]}
              name="CardStatement"
              component={CardStatement}
            />
            <PermissionedRoute
              path="/transaction-report"
              allowedPermissions={[permissionsConstants.VIEW_CARD_STATEMENT]}
              name="TransactionReport"
              component={TransactionReport}
            />
            <PermissionedRoute
              path="/card-search"
              allowedPermissions={[permissionsConstants.VIEW_CARDS]}
              name="CardSearch"
              component={CardSearch}
            />
            <PermissionedRoute
              path="/audit-trail"
              allowedPermissions={[permissionsConstants.VIEW_ACTIVITY_LOG]}
              name="AuditTrail"
              component={AuditTrail}
            />
          </div>
        </div>
      </main>
    </MainWrapper>
  </Switch>
);

export default Router;
